import { HTTP,handleSessionExpired } from '../../utils'

export const authenticateWebWidget = () => {
  return HTTP().get('/user/webwidget')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getTourElements = () => {
  return HTTP().get('/tour/role')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getTourUserStatus = () => {
  return HTTP().get('/tour/userStatus')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const putUpdateTourUserStatus = (tourStatus) => {
  return HTTP().put('/tour/userStatus/update', tourStatus)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const authenticateZendesk = (redirect) => {
  return HTTP().get('/user/zendesk?return_to=' + redirect)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getUserInfo = (token) => {
  return HTTP(token).get('/user/info')
  .then(response => {
    return response.data
  })
  .catch(e => {
    handleSessionExpired(e)
    console.log('Error:' + e)
  })
}

export const postSaveDataOptOut = (data) => {
  var url = '/user/dataOptOut'
  return HTTP().post(url, data)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
    let res = {
      status: 400
    }
    return res.data
  })
}

export const getUsers = (parentSpaceId, page, count, role, name) => {
  var url = '/user/search?parentSpaceId=' + parentSpaceId + '&role=' + role + '&page=' + page + '&count=' + count
  if (name) {
    url = url + '&name=' + name
  }
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getUser = (uuid) => {
  var url = '/user/' + uuid
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const getUserForEmployer = (uuid) => {
  var url = '/user/employer/view/' + uuid
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getUserAdvisor = (uuid) => {
  var url = '/user/advisor/' + uuid
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const updatePassword = (data) => {
  var url = '/user/updatePassword'
  return HTTP().post(url, data)
  .then(res => {
    return res
  })
  .catch(e => {
    console.log(e)
    let res = {
      status: 400
    }
    return res
  })
}

export const saveUser = (uuid, user) => {
  var url = '/user/' + uuid
  return HTTP().put(url, user)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const saveUserProfile = (uuid, user) => {
  var url = '/user/updateProfile/' + uuid
  return HTTP().put(url, user)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const updateUserContactInfo = (contactInfo) => {
  return HTTP().put('/user/contactinfo', contactInfo)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const updateUserNewEmail = (oldEmail, newEmail) => {
  var url = '/user/update/email/' + oldEmail+'/to/'+newEmail
  return HTTP().put(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const deleteUser = (uuid) => {
  var url = '/user/' + uuid
  return HTTP().delete(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const createUser = (parentSpaceId, user) => {
  var url = '/user/create/' + parentSpaceId
  return HTTP().put(url, user)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const createStudentUserByEmail = (parentSpaceId, emails) => {
  var url = '/user/createStudent/' + parentSpaceId
  return HTTP().post(url, emails)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const doCsvUploadForUsers = (institutionId, createdByUuid, fileData) => {
  if (!institutionId || !createdByUuid) {
    return
  }
  let url = '/user/csvUserUpload/' + institutionId + '?' + createdByUuid
  return HTTP().post(url, fileData)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const launchSubscriptionCheckout = (planType) => {
  return HTTP().post('/clearynext/launchStripeSubscriptionCheckout/' + planType, {})
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const launchStripeSubscriptionSetup = (planType) => {
  return HTTP().post('/clearynext/launchStripeSubscriptionSetup/' + planType, {})
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const launchStripeSubscriptionCreation = (planType, sessionId) => {
  return HTTP().post('/clearynext/createStripeSubscription/' + planType + '/' + sessionId, {})
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getStripeSubscriptionDetail = (data) => {
  let url = '/clearynext/getStripeSubscriptionDetail/' + data.uuid
  if (data.sessionId) {
    url += '/' + data.sessionId
  }
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const changeStripeSubscription = (planType) => {
  return HTTP().post('/clearynext/changeStripeSubscription/' + planType, {})
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const cancelOrReactivateStripeSubscription = (cancelOrReactivate) => {
  return HTTP().post('/clearynext/cancelOrReactivateStripeSubscription/' + cancelOrReactivate, {})
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getUserSubscriptions = () => {
  return HTTP().get('/user/subscriptions')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getUserPaymentMethods = () => {
  return HTTP().get('/user/paymentMethods')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const putCreateUserPaymentMethod = (paymentMethodObj) => {
  return HTTP().put('/user/paymentMethods/create', paymentMethodObj)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const putCreateUserSubscription = (userSubscriptionObj) => {
  return HTTP().put('/user/subscriptions/create', userSubscriptionObj)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const putCancelUserSubscription = (subscriptionUuid) => {
  return HTTP().put('/user/subscriptions/' + subscriptionUuid + '/delete')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getUserTransactions = () => {
  return HTTP().get('/transaction/userTransactions')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const updateUserProfileResume = (uuid, resume) => {
  const url = '/user/updateProfileResume/' + uuid
  return HTTP().put(url, resume)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const updateUserProfileResumeAsPrimary = (uuid, id) => {
  return HTTP().put('/user/updateProfileResumeAsPrimary/' + uuid + '/' + id)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const deleteUserProfileResume = (uuid, id) => {
  return HTTP().delete('/user/deleteProfileResume/' + uuid + '/' + id)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const deleteSubscription = (transactionObj) => {
  return HTTP().put('/transaction/deleteSubscription', transactionObj)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getConnectionInfo = () => {
  return HTTP().get('/user/pragyaai/connectioninfo')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}



// WEBPACK FOOTER //
// ./src/app/user/api.js